const initialState = {};

export function handleLogout(history) {
  sessionStorage.removeItem('@auth/userName');
  sessionStorage.removeItem('@auth/token');
  sessionStorage.removeItem('@auth/company');
  sessionStorage.removeItem('@auth/usuarioDev');
  sessionStorage.removeItem('@auth/usuarioSup');
  history.push('/login');
  return {
    type: 'LOGOUT',
    initialState,
  };
}
